import { BP, Colors, mq, ZIndex } from '~/styles';
import { type TStyleSheet } from '~/types/emotion-styles';

const styles: TStyleSheet = {
  transcriptContainer: {
    width: '100vw',
    backgroundColor: Colors.secondaryDeepBlue,
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: ZIndex.fullPlayerPanel,
    overflow: 'hidden',
    transition: 'height 0.3s ease',
    height: '85vh', // Default expanded height for desktop
    [mq(BP.Large)]: {
      width: '70%',
      margin: '0 auto',
      position: 'relative',
      right: 0,
      top: 0,
    },
  },
  transcriptContent: {
    padding: '20px 40px', // Increased padding left and right
    backgroundColor: Colors.secondaryDeepBlue,
    height: 'calc(85vh - 50px)', // Content height for desktop
    overflowY: 'auto',
    fontSize: '18px', // Make text slightly larger

    '& p': {
      margin: '24px 0', // Full line breaks between paragraphs
      lineHeight: '1.8', // Increased line height for readability
      color: Colors.white, // Ensure text color remains white
    },

    [mq(BP.Large)]: {
      overflowY: 'auto',
    },
  },
  transcriptHeader: {
    padding: '16px 20px',
    backgroundColor: Colors.secondaryDeepBlue,
    color: Colors.white,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '50px',
    [mq(BP.Large)]: {
      padding: '20px 40px',
    },
  },

  transcriptTitle: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: Colors.white,
  },

  toggleButton: {
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    color: Colors.white,
    padding: '6px 14px',
    borderRadius: '100px',
    fontSize: '12px',
    fontWeight: '700',
    textAlign: 'center',
    fontFamily: 'Maison Neue',
    lineHeight: '135%',
    letterSpacing: '0.24px',
    cursor: 'pointer',
    border: 'none',
    transition: 'background-color 0.3s ease',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.25)',
    },
  },

  collapsedContainer: {
    height: '50px', // Collapse to header height only when collapsed
  },
};

export default styles;
